import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Коммерческий туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p className="sub">ШОП-ТУР</p>
                    <p>Туристская поездка, целью которой является покупка определенных видов товаров, характерных для
                        страны пребывания, для их последующей реализации.</p>
                </div>
            </div>
        </>
    );
}